import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, Phone } from "lucide-react";
import XIcon from "@/components/XIcon";
import { CANDIDATE, NAV_LINKS } from "@/data/campaign";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-pine-950 text-paper">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 lg:grid-cols-[2fr_1fr_1.5fr]">
      <div>
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center bg-terra-500 font-serif text-lg font-semibold text-paper">AN</span>
          <div className="leading-tight">
            <p className="font-serif text-lg font-semibold">{CANDIDATE.name}</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-paper/50">For Ward 11 · Mississauga</p>
          </div>
        </div>
        <p className="mt-6 max-w-sm font-serif text-xl italic leading-relaxed text-paper/80">
          “{CANDIDATE.quote}”
        </p>
      </div>

      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-terra-400">Navigate</p>
        <ul className="mt-5 space-y-3">
          {NAV_LINKS.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm text-paper/70 transition-colors hover:text-terra-400"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-terra-400">Reach Amin Directly</p>
        <div className="mt-5 space-y-3 text-sm">
          <a
            href={`tel:${CANDIDATE.phone.replace(/-/g, "")}`}
            data-testid="footer-phone-link"
            className="flex items-center gap-3 text-paper/70 transition-colors hover:text-terra-400"
          >
            <Phone className="h-4 w-4" /> {CANDIDATE.phone}
          </a>
          <a
            href={`mailto:${CANDIDATE.email}`}
            data-testid="footer-email-link"
            className="flex items-center gap-3 text-paper/70 transition-colors hover:text-terra-400"
          >
            <Mail className="h-4 w-4" /> {CANDIDATE.email}
          </a>
        </div>
        <div className="mt-6 flex gap-3">
          {[
            { icon: Facebook, id: "facebook", href: "https://facebook.com" },
            { icon: XIcon, id: "twitter", href: "https://x.com/Amnanji" },
            { icon: Instagram, id: "instagram", href: "https://instagram.com" },
          ].map(({ icon: Icon, id, href }) => (
            <a
              key={id}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`footer-social-${id}`}
              aria-label={id}
              className="flex h-10 w-10 items-center justify-center border border-paper/15 text-paper/70 transition-colors hover:border-terra-400 hover:text-terra-400"
            >
              <Icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      </div>
    </div>
    <div className="border-t border-paper/10">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 font-mono text-[11px] uppercase tracking-[0.15em] text-paper/40 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <span data-testid="footer-copyright">© 2026 Campaign to Elect {CANDIDATE.name}</span>
        <div className="flex items-center gap-6">
          <Link
            to="/privacy"
            data-testid="footer-link-privacy-policy"
            className="transition-colors hover:text-terra-400"
          >
            Privacy Policy
          </Link>
          <span>Ward 11 · 43.5890° N, 79.6441° W</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
